var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 1.67427L17.1232 10.6964L17.2329 11.047H17.6003H26.7875L19.339 16.6663L19.0577 16.8785L19.1629 17.2148L21.9981 26.2753L14.6011 20.6949L14.3 20.4678L13.9989 20.6949L6.6019 26.2753L9.43709 17.2148L9.54231 16.8785L9.26103 16.6663L1.81245 11.047H10.9996H11.3671L11.4768 10.6964L14.3 1.67427Z",
    stroke: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.5e6638077d37d290c924eed5f7725891.svg";
export { ForwardRef as ReactComponent };